import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../_metronic/_partials/controls";
import { WelcomeWidget } from "./Component/WelcomeWidget";
import { ProgressWidget } from "./Component/ProgressWidget";
import { ProgressWidget as ProgressWidget2 } from "./Component/SecondRow/ProgressWidget";
import { Link } from "react-router-dom";
import {
  checkWizard,
  dashboardGetTotalDonation,
  dashboardGetTotalDonationCount,
  findNotificationOrg,
  getCurrentMonthDonationAmount,
  getCurrentMonthDonor,
  getTargetPenerimaanDonasi,
  getTopProgram,
  getTotalDonationChannel,
  getTotalDonationEchannel,
  getTotalDonationThisDay,
  getTotalDonationThisMonth,
  getTotalDonationThisWeek,
  getTotalDonationThisYear,
  getTotalDonationType,
  getTotalDonor,
  getTotalDonorGender,
  getTotalDonorIndividu,
  getTotalDonorInstitusi,
  getTotalDonorPremium,
  getTotalFundType,
  getTotalNominalTransaksi,
  getTotalProgram,
  getTotalProject,
  getTotalRetensiDonatur
} from "./crud/dashboardCrud";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actions as auth } from "../Auth/_redux/authRedux";
import { toastOption } from "../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";
import NotificationDashboard from "./Component/NotificationDashboard/NotificationDashboard";
import { ActionButton } from "../../../_metronic/_partials/controls/ActionButton";
import TotalDataCountWidget from "./components/TotalDataCountWidget";
import TopProgramTable, { TopTableList } from "./components/TopTableList";
import { TileCustomListWidget } from "./Component/TileCustomListWidget";
import { currencyFormatter } from "../../../_metronic/_helpers";
import TotalDonation from "../SuperAdmin/pages/dashboard/DashboardWidget/TotalDonation";
import { TileCustomPieWidget } from "./Component/ThirdRow/TileCustomPieWidget";
import { BarWidgetCustom } from "./Component/SixthRow/BarWidgetCustom";
import { TilesRetentionDonatur } from "./Component/FirstRow/TilesRetentionDonatur";
import MoneyIcon from "@material-ui/icons/Money";

import { TilesDonationWidget } from "./Component/FirstRow/TilesDonationWidget";

export default function DashboardPage2() {
  const dispatch = useDispatch();

  const [steps, setSteps] = useState([]);
  const [showWizard, setShowWizard] = useState(true);
  const [dataDonationThisMonth, setDataDonationThisMonth] = useState([]);
  const [notificationOrg, setNotificationOrg] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalDataCount, setTotalDataCount] = useState({
    total_donation_amount: 0,
    total_donor: 0,
    total_new_donor: 0,
    total_program: 0,
    total_project: 0,
    total_fund_type: 0,
    total_donation_count: 0,
    total_amount: 0
  });
  const [topProgramList, setTopProgramList] = useState([]);

  const [dashboardData, setDashboardData] = useState({
    totalDonation: {
      loading: false,
      data: []
    },
    donationType: {
      total: [],
      type: [],
      loading: false
    },
    donationChannel: {
      total: [],
      channel: [],
      loading: false
    },
    donationFavAmount: {
      transaction: [],
      loading: false
    },
    topDonationEchannel: {
      donation: [],
      loading: false
    },
    topDonorIndividu: {
      donor: [],
      loading: false
    },
    topDonationInstitution: {
      donation: [],
      loading: false
    },
    donaturGender: {
      donor: [],
      total: [],
      loading: false
    },
    donaturRetention: {
      percent: 0,
      total: 0,
      loading: false
    },
    donaturPremium: {
      data: [],
      loading: false
    },
    achivementYearlyTarget: {
      donation: 0,
      donation_percentage: 0,
      growth: 0,
      loading: false
    }
  });

  function handleLoadingDashboard(key, value) {
    setDashboardData(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        loading: value
      }
    }));
  }

  // * Get Total Donation
  async function getTotalDonation() {
    handleLoadingDashboard("totalDonation", true);
    const typeList = ["today", "this_week", "this_month"];
    const totalDonationData = [];
    for (const type of typeList) {
      const attr = {
        label: "",
        icon: "",
        color: ""
      };
      switch (type) {
        case "today":
          attr.label = "Donasi Hari Ini";
          attr.icon = "fas fa-calendar-day";
          attr.color = "#FC1754";
          break;
        case "this_week":
          attr.label = "Donasi Minggu Ini";
          attr.icon = "fas fa-calendar-week";
          attr.color = "#247B9E";
          break;
        case "this_month":
          attr.label = "Donasi Bulan Ini";
          attr.icon = "fas fa-calendar-alt";
          attr.color = "#1BC5BD";
          break;
        case "this_year":
          attr.label = "Donasi Tahun Ini";
          attr.icon = "fas fa-calendar-days";
          attr.color = "#FC1754";
          break;
        case "overall":
          attr.label = "Donasi Keseluruhan";
          attr.icon = "fas fa-calendar-clock";
          attr.color = "#1BC5BD";
          break;

        default:
          attr.label = "";
          attr.icon = "";
          attr.color = "";
          break;
      }
      const {
        data: {
          data: { total_donation_amount }
        }
      } = await dashboardGetTotalDonation(type);
      totalDonationData.push({
        attr,
        total_donation_amount
      });
    }

    handleLoadingDashboard("totalDonation", false);

    setDashboardData(prev => ({
      ...prev,
      totalDonation: {
        loading: false,
        data: totalDonationData
      }
    }));
  }

  // * Get Donation Type (Pie Chart)
  async function getDonationType() {
    handleLoadingDashboard("donationType", true);
    getTotalDonationType()
      .then(response => {
        setDashboardData(prev => ({
          ...prev,
          donationType: {
            type: response.data.data.donation_type.map(item => item.type),
            total: response.data.data.donation_type.map(item =>
              Number(item.total_donasi)
            )
          }
        }));
        handleLoadingDashboard("donationType", false);
      })
      .catch(error => {
        handleLoadingDashboard("donationType", false);
      });
  }

  // * Get Donation Channel (Pie Chart)
  async function getDonationChannel() {
    handleLoadingDashboard("donationChannel", true);
    getTotalDonationChannel()
      .then(response => {
        setDashboardData(prev => ({
          ...prev,
          donationChannel: {
            channel: response.data.data.donation_type.map(item => item.type),
            total: response.data.data.donation_type.map(item =>
              Number(item.total_donasi)
            )
          }
        }));
        handleLoadingDashboard("donationChannel", false);
      })
      .catch(error => {
        handleLoadingDashboard("donationChannel", false);
      });
  }

  // * Get Donation Favorite Amount
  async function getFavoriteDonationAmount() {
    handleLoadingDashboard("donationFavAmount", true);
    getTotalNominalTransaksi()
      .then(response => {
        setDashboardData(prev => ({
          ...prev,
          donationFavAmount: {
            transaction: response.data.data.map(
              item => item.jumlah_penerimaan_donasi
            )
          }
        }));
        handleLoadingDashboard("donationFavAmount", false);
      })
      .catch(error => {
        handleLoadingDashboard("donationFavAmount", false);
      });
  }

  // * Get Top 10 Donation By Echannel
  function getTopDonationEchannel() {
    handleLoadingDashboard("topDonationEchannel", true);
    getTotalDonationEchannel()
      .then(response => {
        setDashboardData(prev => ({
          ...prev,
          topDonationEchannel: {
            donation: response.data.data
          }
        }));
        handleLoadingDashboard("topDonationEchannel", false);
      })
      .catch(error => {
        handleLoadingDashboard("topDonationEchannel", false);
      });
  }

  // * Get Top 10 Donation By Donor Individu
  function getTopDonorIndividu() {
    handleLoadingDashboard("topDonorIndividu", true);
    getTotalDonorIndividu()
      .then(response => {
        setDashboardData(prev => ({
          ...prev,
          topDonorIndividu: {
            donor: response.data.data
          }
        }));
        handleLoadingDashboard("topDonorIndividu", false);
      })
      .catch(error => {
        handleLoadingDashboard("topDonorIndividu", false);
      });
  }

  // * Get Top 10 Donation BInstitution
  function getTopDontionInstitution() {
    handleLoadingDashboard("topDonationInstitution", true);
    getTotalDonorInstitusi()
      .then(response => {
        setDashboardData(prev => ({
          ...prev,
          topDonationInstitution: {
            donation: response.data.data
          }
        }));
        handleLoadingDashboard("topDonationInstitution", false);
      })
      .catch(error => {
        handleLoadingDashboard("topDonationInstitution", false);
      });
  }

  // * Get Donatur Gender
  function getDonorGender() {
    handleLoadingDashboard("donaturGender", true);
    getTotalDonorGender()
      .then(response => {
        setDashboardData(prev => ({
          ...prev,
          donaturGender: {
            donor: response.data.data.map(item => item.gender),
            total: response.data.data.map(item => Number(item.total_donatur))
          }
        }));
        handleLoadingDashboard("donaturGender", false);
      })
      .catch(error => {
        handleLoadingDashboard("donaturGender", false);
      });
  }

  function getDonaturRetention() {
    handleLoadingDashboard("donaturRetention", true);
    getTotalRetensiDonatur()
      .then(response => {
        setDashboardData(prev => ({
          ...prev,
          donaturRetention: {
            percent: response.data.data.persen_retensi,
            total: response.data.data.jumlah_retensi
          }
        }));
        handleLoadingDashboard("donaturRetention", false);
      })
      .catch(error => {
        handleLoadingDashboard("donaturRetention", false);
      });
  }

  function getDonaturPremium() {
    handleLoadingDashboard("donaturPremium", true);
    getTotalDonorPremium()
      .then(response => {
        setDashboardData(prev => ({
          ...prev,
          donaturPremium: {
            data: response.data.data
          }
        }));
        handleLoadingDashboard("donaturPremium", false);
      })
      .catch(error => {
        handleLoadingDashboard("donaturPremium", false);
      });
  }

  function getTargetDonation() {
    handleLoadingDashboard("achivementYearlyTarget", true);
    getTargetPenerimaanDonasi()
      .then(response => {
        setDashboardData(prev => ({
          ...prev,
          achivementYearlyTarget: {
            growth: response.data.data.pertumbuhan,
            donation_percentage: response.data.data.persen_target ?? 0,
            donation: response.data.data.target
          }
        }));
        handleLoadingDashboard("achivementYearlyTarget", false);
      })
      .catch(error => {
        handleLoadingDashboard("achivementYearlyTarget", false);
      });
  }

  const { user } = useSelector(
    state => ({
      user: state.auth.user
    }),
    shallowEqual
  );

  async function getSteps() {
    setLoading(true);

    try {
      const { data: { data = {} } = {} } = await checkWizard();

      const arrayStep = [];
      const path = [
        "master-data/organization",
        "master-data/donation/fundtype",
        "master-data/donation/program",
        "master-data/donation/channel",
        "master-data/bank/account-bank",
        "master-data/payment/payment-method"
      ];
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        arrayStep.push({ ...element, path: path[i] });
      }
      setSteps(arrayStep);
    } catch (error) {
      toast.error(error.message, toastOption);
    } finally {
      setLoading(false);
    }
  }

  async function getDonationThisMonth() {
    try {
      const resThisMonth = await getTotalDonationThisMonth();
      setDataDonationThisMonth(resThisMonth.data.data);
    } catch (error) {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
    }
  }

  async function findNoticiation() {
    const params = {
      pageNumber: 1,
      pageSize: 10,
      filter: {
        organization_uuid: user.organization_uuid
      }
    };
    const result = await findNotificationOrg(params);
    setNotificationOrg(result.data.data.items);
  }

  const onCloseNotification = notif => {
    setNotificationOrg(prev => {
      const temp = [...prev];
      const newArray = temp.filter(item => item.uuid !== notif.uuid);
      return newArray;
    });
  };

  useEffect(() => {
    getSteps();
    getDonationThisMonth();
    findNoticiation();
    getAllCountData();

    getTotalDonation();
    getDonationType();
    getDonationChannel();
    getFavoriteDonationAmount();

    getTopDonationEchannel();
    getTopDonorIndividu();
    getTopDontionInstitution();
    getDonorGender();
    getDonaturRetention();
    getDonaturPremium();
    getTargetDonation();
  }, []);

  const getAllCountData = async () => {
    const {
      data: { total_donation_amount }
    } = await getCurrentMonthDonationAmount();

    const {
      data: { total_donor }
    } = await getTotalDonor();

    const {
      data: { total_new_donor }
    } = await getCurrentMonthDonor();

    const {
      data: { total_program }
    } = await getTotalProgram();

    const {
      data: { total_project }
    } = await getTotalProject();

    const {
      data: { total_fund_type }
    } = await getTotalFundType();

    const {
      data: { top_program_list }
    } = await getTopProgram();

    const {
      data: {
        data: { donation_count, total_amount }
      }
    } = await dashboardGetTotalDonationCount();

    setTotalDataCount(prev => ({
      ...prev,
      total_donation_amount: total_donation_amount.total_amount,
      total_donor,
      total_new_donor,
      total_program,
      total_project,
      total_fund_type,
      total_donation_count: donation_count,
      total_amount
    }));

    setTopProgramList(top_program_list);
  };

  return (
    <>
      <div className="row mb-4">
        <div className="col">
          <NotificationDashboard
            notifications={notificationOrg}
            onCloseNotification={onCloseNotification}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <WelcomeWidget user={user} />
        </div>
      </div>
      {steps.some(({ isDone }) => !isDone) && showWizard && (
        <div className="row">
          <div className="col">
            <br></br>
            <Card className="example example-compact">
              <CardHeader title="Kelengkapan Data">
                <CardHeaderToolbar>
                  {steps.some(({ isDone }) => !isDone) && (
                    <ActionButton
                      type="button"
                      onClick={() => setShowWizard(false)}
                      loading={loading}
                      text="Close"
                    />
                  )}
                </CardHeaderToolbar>
              </CardHeader>
              <CardBody>
                <div className="card-body pt-4">
                  <div className="timeline timeline-6 mt-3">
                    {steps.map(row => (
                      <div
                        className="timeline-item align-items-start"
                        key={row.name}
                      >
                        <div className="timeline-label font-weight-bolder text-dark-75 font-size-lg"></div>
                        {/* {
                                  row.name ==='Bank Account'&&row.count ===0
                                } */}
                        {row.isDone ? (
                          <div className="timeline-badge">
                            <i className="fa fa-check text-success icon-l"></i>
                          </div>
                        ) : (
                          <div className="timeline-badge">
                            <i className="fa fa-genderless text-success icon-xl"></i>
                          </div>
                        )}
                        {/* {
                                  row.count>1?
                                  (
                                    <div className="timeline-badge">
                                      <i className="fa fa-check text-success icon-l"></i>
                                  </div>
                                  ):(
                                    <div className="timeline-badge">
                                      <i className="fa fa-genderless text-success icon-xl"></i>
                                    </div>
                                  )
                                } */}
                        <Link to={row.path}>
                          <div className="font-weight-mormal font-size-lg timeline-content text-muted pl-3">
                            <span className="text-primary">{row.name}</span>
                          </div>
                          {/* <br/> */}
                          <div className="font-weight-mormal font-size-lg timeline-content text-muted pl-3">
                            <span className="text-dark">
                              {row.isDone
                                ? "Organisasi telah melengkapi "
                                : "Organisasi belum melengkapi "}{" "}
                              {row.name}.
                            </span>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      )}
      <div className="row mt-6">
        <div className="col-lg-3 col-md-6 col-sm-12">
          <TilesDonationWidget
            className="gutter-b"
            widgetHeight="450px"
            persen={dashboardData.achivementYearlyTarget.donation_percentage}
            loading={dashboardData.achivementYearlyTarget.loading}
            pertumbuhan={dashboardData.achivementYearlyTarget.growth}
            target={dashboardData.achivementYearlyTarget.donation}
            chartID="capaianTargetTahunan"
          />
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12">
          <TilesRetentionDonatur
            className="gutter-b"
            widgetHeight="450px"
            chartID="retention2"
            total={dashboardData.donaturRetention.total}
            persen={dashboardData.donaturRetention.percent}
            loading={dashboardData.donaturRetention.loading}
          />
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <Card style={{height: '450px'}} className="gutter-b">
            <CardBody>
              <h3 className="h3">
                <MoneyIcon className="mr-1" />
                Jumlah Total Transaksi
              </h3>
              <div className="text-right">
                <div className="h1 m-5">
                  {totalDataCount.total_donation_count}
                </div>
                <div className="h1 m-5">
                  {currencyFormatter(totalDataCount.total_amount)}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      <TotalDataCountWidget dataCount={totalDataCount} widgetHeight="450px" />
      <TotalDonation
        data={dashboardData.totalDonation.data}
        loading={dashboardData.totalDonation.loading}
      />
      <div className="row">
        <div className="col">
          <Card>
            <ProgressWidget dataDonationThisMonth={dataDonationThisMonth} />
          </Card>
        </div>
      </div>
      <br />

      <br />
      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-12 mb-8">
          <TileCustomPieWidget
            title="Tipe Donasi"
            loading={dashboardData.donationType.loading}
            series={dashboardData.donationType.total}
            labels={dashboardData.donationType.type}
            chartID="donation_type"
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 mb-8">
          <TileCustomPieWidget
            title="Tipe Channel"
            loading={dashboardData.donationChannel.loading}
            series={dashboardData.donationChannel.total}
            labels={dashboardData.donationChannel.channel}
            chartID="donation_channel"
          />
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 mb-8">
          <TileCustomPieWidget
            title="Gender Donor"
            className="gutter-b"
            loading={dashboardData.donaturGender.loading}
            series={dashboardData.donaturGender.total}
            labels={dashboardData.donaturGender.donor}
            chartID="donor_gender"
            widgetHeight="450px"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4 col-md-6">
          <TileCustomListWidget
            className="gutter-b"
            title="Top 10 Donasi Echannel"
            th1="ECHANNEL"
            th2="Total"
            data={dashboardData.topDonationEchannel.donation}
            loading={dashboardData.topDonationEchannel.loading}
          />
        </div>
        <div className="col-xl-4 col-md-6">
          <TileCustomListWidget
            className="gutter-b"
            title="Top 10 Donasi Individu"
            th1="Nama"
            th2="Total"
            data={dashboardData.topDonorIndividu.donor}
            loading={dashboardData.topDonorIndividu.loading}
          />
        </div>
        <div className="col-xl-4 col-md-12">
          <TileCustomListWidget
            className="gutter-b"
            title="Top 10 Donasi Institusi"
            th1="Institusi"
            th2="Total"
            data={dashboardData.topDonationInstitution.donation}
            loading={dashboardData.topDonationInstitution.loading}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <TopTableList
            className="gutter-b"
            title="Top 10 Program"
            th1="Program"
            th2="Donasi"
            data={topProgramList}
            // loading={DonationEchannelLoading}
          />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <TileCustomListWidget
            className="gutter-b"
            title={`Top Donatur Premium`}
            th1="Nama"
            th2="Total"
            data={dashboardData.donaturPremium.data}
            loading={dashboardData.donaturPremium.loading}
          />
        </div>
      </div>
      <BarWidgetCustom
        title="Nominal Donasi Favorit"
        className="gutter-b"
        loading={dashboardData.donationFavAmount.loading}
        series={dashboardData.donationFavAmount.transaction}
        chartID="nominal_favorite"
      />
    </>
  );
}
